import type { Route } from '~/core/router'

import { options } from '~/core/flags'
import * as details from '~/routes/motn/details'
import { aye } from '~/shared/helpers'

export const route: Route = {
  filter: {
    source: options.$movieNightEnabled,
    fn: (movieNightEnabled) => aye(movieNightEnabled),
  },
  component: [details.Title, details.MotnDetailsPage],
  init: details.model.init,
  left: details.model.left,
}
